"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useDebounce = function useDebounce(value, delay) {
  var _ref = (0, react_1.useState)(value),
      _ref2 = _slicedToArray(_ref, 2),
      debouncedValue = _ref2[0],
      setDebouncedValue = _ref2[1];

  (0, react_1.useEffect)(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      return clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

exports.default = useDebounce;